<script lang="ts">
    import { _ } from "svelte-i18n"
    import { mdiInformationOutline, mdiMagnify } from "@mdi/js"
    import { RuleEngine } from "../RuleEngine"
    import InfoText from "./InfoText.svelte"
    import Modal from "../../../widgets/Modal.svelte"
    import Icon from "../../../widgets/Icon.svelte"

    let {
        ftpAssetsUrl,
        currentChoices = null,
        name = null,
        value = $bindable(),
        values = $bindable(),
        multiple = false,
        dependsOn,
        label,
        css,
        filterPlaceholder,
        showFilterIfMoreThan,
        highlightedValue,
        choices,
        onInvalidConfig,
    }: FieldComponentProps = $props()

    values = values || null

    let activeModal: {
        [key: number]: boolean
    } = $state({})
    const ruleEngine = new RuleEngine()

    let displayComponent: boolean = $derived(dependsOn ? ruleEngine.resolve(dependsOn, values) : true)
    let showChoiceNotSelectableInfo: boolean = $derived(
        choices.some(
            (choices) => choices.dependsOn && !ruleEngine.resolve(choices.dependsOn, values) && choices.id === value
        )
    )
    let filterInputValue = $state("")
    let filteredChoices = $derived(
        choices.filter((choice) => {
            const filterValue = filterInputValue.toLowerCase()
            return (
                filterInputValue === "" ||
                choice.title?.toLowerCase().includes(filterValue) ||
                choice.description?.toLowerCase().includes(filterValue)
            )
        })
    )

    if (multiple && !value) value = []
    if (!value || (Array.isArray(value) && !value.length)) {
        if (!value) {
            if (currentChoices && currentChoices[name] && value !== currentChoices[name]) value = currentChoices[name]
        } else if (Array.isArray(value)) value.push(currentChoices[name])
    }

    const select = (choice: { id: number | string }) => {
        if (multiple) {
            value = Array.isArray(value) ? value : []
            value.includes(choice.id) ? value.splice(value.indexOf(choice.id), 1) : value.push(choice.id)
        } else value = value === choice.id ? null : choice.id
        value = value
    }

    const isChoiceResolvedDependsOn = (choice: { id: number | string; dependsOn?: any }, values: any) => {
        if (choice.dependsOn && values) {
            const resolved = ruleEngine.resolve(choice.dependsOn, values)
            if (!resolved && choice.id === value) updateChoiceNotSelectableInfo(true)
            else if (resolved && choice.id === value) updateChoiceNotSelectableInfo(false)
            return resolved
        } else if (!choice.dependsOn && values) if (choice.id === value) updateChoiceNotSelectableInfo(false)

        return true
    }

    const updateChoiceNotSelectableInfo = (show: boolean) => {
        onInvalidConfig(showChoiceNotSelectableInfo)
    }

    const nl2br = (str: string) => {
        if (typeof str === "undefined" || str === null) return ""
        var breakTag = "<br/>"
        return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2")
    }

    $effect(() => {
        if (dependsOn && !displayComponent) {
            value = multiple ? [] : null
        }
    })
</script>

{#if displayComponent}
    <div class="image-select">
        {#if label}
            <label for="">{label}</label>
        {/if}

        {#if showChoiceNotSelectableInfo}
            <InfoText
                css="warning"
                label="Achtung!"
                text="Die zuvor gewählte Option ist nicht mehr passend zur aktuellen Konfiguration. Bitte wählen Sie erneut eine der verfügbaren Optionen."
                values={{}}
            />
        {/if}

        {#if choices.length > (showFilterIfMoreThan ? showFilterIfMoreThan : 10)}
            <form class="image-select-filter" onsubmit={(e) => e.preventDefault()}>
                <Icon path={mdiMagnify} />
                <input
                    type="text"
                    bind:value={filterInputValue}
                    placeholder={filterPlaceholder ? filterPlaceholder : $_("product.search-color")}
                />
            </form>
        {/if}

        <div class="image-select-choices">
            {#each filteredChoices || [] as choice, i}
                {#if isChoiceResolvedDependsOn(choice, values)}
                    <div
                        class="image-select-item"
                        style={css}
                        class:standard-variant={highlightedValue === choice.id || choice.highlighted}
                    >
                        {#if choice.color}
                            <!-- svelte-ignore a11y_click_events_have_key_events -->
                            <!-- svelte-ignore a11y_no_static_element_interactions -->
                            <div
                                class="image-select-color"
                                style={`background: ${choice.color}`}
                                class:selected={value && multiple ? value?.includes(choice.id) : value === choice.id}
                                onclick={() => select(choice)}
                            ></div>
                        {:else if choice.imageUrl}
                            <!-- svelte-ignore a11y_click_events_have_key_events -->
                            <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
                            <img
                                src="{ftpAssetsUrl}{choice.imageUrl}"
                                alt={choice.title}
                                class:selected={value && multiple ? value?.includes(choice.id) : value === choice.id}
                                onclick={() => select(choice)}
                                loading="lazy"
                            />
                        {/if}
                        {#if choice.title}
                            <div class="image-select-title">{choice.title}</div>
                        {/if}
                        {#if choice.description}
                            <div class="image-select-description">
                                {choice.description}
                            </div>
                        {/if}
                        {#if choice.informationText}
                            <button
                                class="image-select-information-icon button transparent"
                                aria-label="Information"
                                onclick={(e) => {
                                    e.stopPropagation()
                                    activeModal[i] = true
                                }}
                            >
                                <Icon path={mdiInformationOutline} />
                            </button>
                            <Modal bind:show={activeModal[i]}>
                                {@html nl2br(choice.informationText)}
                            </Modal>
                        {/if}
                    </div>
                {/if}
            {/each}
        </div>
    </div>
{/if}
